import { useState, useEffect } from 'react';
import BottomNav from './components/BottomNav';
import SignalHall from './components/SignalHall';
import ONeil from './components/ONeil';
import StockMagic from './components/StockMagic';
import Profile from './components/Profile';
import SplashScreen from './components/SplashScreen';
import ErrorBoundary from './components/ErrorBoundary';
import { DataProvider } from './context/DataContext';

export default function App() {
  const [activeTab, setActiveTab] = useState('signal');
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  // Initialize theme based on system preference
  useEffect(() => {
    const hour = new Date().getHours();
    const prefersDark = hour < 6 || hour >= 18;
    setIsDarkMode(prefersDark);
  }, []);

  // Apply dark mode class to document
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'signal':
        return <SignalHall />;
      case 'oneil':
        return <ONeil />;
      case 'magic':
        return <StockMagic />;
      case 'profile':
        return <Profile isDarkMode={isDarkMode} onToggleTheme={toggleTheme} />;
      default:
        return <SignalHall />;
    }
  };

  return (
    <ErrorBoundary>
      <DataProvider>
        <div className="h-screen flex flex-col bg-background max-w-[480px] mx-auto">
          {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
          
          {/* Main Content Area */}
          <div className="flex-1 overflow-hidden pb-14">
            {renderContent()}
          </div>

          {/* Bottom Navigation */}
          <BottomNav activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
      </DataProvider>
    </ErrorBoundary>
  );
}